module.exports = "#user-dropdown-toggle .icon-user {\n  margin-right: 4px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/dashboard/header/header.component.scss
// module id = ./src/app/layouts/dashboard/header/header.component.scss
// module chunks = main